<div class="loading">
  <img src="../../../assets/loading.svg" alt="Loading..." />
</div>
